import { Box, Button, Grid, IconButton } from "@material-ui/core";
import { Add, Close } from "@material-ui/icons";
import MaterialTable from "material-table";
import React, { useCallback, useRef, useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import {
    createContactUsSocial,
    deleteContactUsSocial,
    getAllContactUsSocial,
    updateContactUsSocial,
} from "../../../../../api/contactUsSocial";
import { uploadImage } from "../../../../../api/uploadApi";
import { toImageUrl } from "../../../../../utils/formatHelper";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { columnsTableSocial, initialTableOptionsSocial } from "../../helpers/settingEvtOption";
import SocialForm from "./SocialForm";
import { isBase64 } from "../../../../../utils/validation";
import { swalCondition } from "../../../../../utils/swalHelper";
import { useSelector } from "react-redux";
export default function ContentSocial() {
    // ref
    const controllerRef = useRef(null);
    const tableRef = useRef(null);

    // global redux state
    const { thisMenuPermission } = useSelector(state => {
        const { menuPermission } = state?.menu;
        return {
            thisMenuPermission: menuPermission?.find(menu => menu?.path === window.location.pathname)?.permission,
        };
    });

    // component state
    const [fileIcon, setFileIcon] = useState([]);
    const [modalForm, setModalForm] = useState(false);
    const [isCreateMode, setIsCreateMode] = useState(false);
    const [tableOptions, setTableOptions] = useState(initialTableOptionsSocial);
    const [contactUsSocialValues, setcontactUsSocialValues] = useState({
        name: "",
        icon: "",
        link: "",
        id: "",
    });

    // fetch data
    const fetchData = useCallback(async query => {
        try {
            const queryParams = {
                page: query?.page + 1 || 1,
                limit: query?.pageSize || 10,
                search: query?.search || "",
                order: query?.orderBy?.field || "contactUsSocialId",
                direction: query?.orderBy?.field ? query?.orderDirection : "desc",
            };
            const res = await getAllContactUsSocial(queryParams, controllerRef.current?.signal);
            if (res) {
                setTableOptions(currentState => ({
                    ...currentState,
                    currentPage: query?.page,
                    pageSize: query?.pageSize || 10,
                    totalData: res?.pagination?.totalData || 0,
                    order: query?.orderBy?.field || "timestamp",
                    direction: query?.orderBy?.field ? query?.orderDirection : "desc",
                }));
                return {
                    data: res?.data || [],
                    page: query?.page || 0,
                    totalCount: res?.pagination?.totalData || 0,
                };
            }
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        } catch (error) {
            console.dir(error);
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        }
    }, []);

    // set formik value
    const setContactFormValue = useCallback(social => {
        setcontactUsSocialValues({
            name: social?.name || "",
            icon: social?.icon || "",
            link: social?.link || "",
            id: social?.contactUsSocialId || "",
        });
    }, []);

    // clear formik value
    const clearContactFormValue = useCallback(() => {
        setcontactUsSocialValues({
            name: "",
            icon: "",
            link: "",
            id: "",
        });
        setFileIcon([]);
    }, []);

    // open modal create form
    const handleShowModalForm = useCallback(() => {
        clearContactFormValue();
        setIsCreateMode(true);
        setModalForm(true);
    }, [clearContactFormValue]);

    // open modal edit form
    const handleShowModalEditForm = useCallback(
        social => {
            const image = [
                {
                    id: 1,
                    name: social?.icon,
                    src: social?.icon
                        ? social?.icon !== "https"
                            ? toImageUrl(social?.icon)
                            : social?.icon
                        : toAbsoluteUrl(""),
                    ///media/HCH/users/empty_img.png
                },
            ];
            setFileIcon(image);
            setContactFormValue(social);
            setIsCreateMode(false);
            setModalForm(true);
        },
        [setContactFormValue],
    );

    const HandleCloseModal = () => {
        setModalForm(false);
    };

    // crate logic
    const handleCreateSocial = useCallback(async social => {
        try {
            let imagePath = "";
            if (social?.icon?.length) {
                imagePath = await uploadImage(social?.icon, controllerRef.current?.signal);
            }
            delete social?.icon;

            // create social
            const isCreateSocial = await createContactUsSocial(
                { ...social, icon: imagePath },
                controllerRef.current?.signal,
            );
            if (isCreateSocial) {
                tableRef.current.onQueryChange();
                setModalForm(false);
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    // update logic
    const handleUpdateSocial = useCallback(async social => {
        try {
            const checkIcon = await isBase64(social.icon);
            let imagePath = "";
            if ((social?.icon?.length > 0) & (checkIcon === true)) {
                imagePath = await uploadImage(social?.icon, controllerRef.current?.signal);
            } else if ((social?.icon?.length > 0) & (checkIcon === false)) {
                imagePath = social?.oldIcon;
            }
            delete social?.icon;

            //update social
            const isUpdateUser = await updateContactUsSocial(
                social?.id,
                { ...social, icon: imagePath },
                controllerRef.current?.signal,
            );
            if (isUpdateUser) {
                tableRef.current.onQueryChange();
                setModalForm(false);
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    // delete logic
    const handleDeleteSocial = useCallback(async social => {
        try {
            const isConfirm = await swalCondition('<div className="h3 t-text-primary">Are you delete?</div>', "", {
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "YES",
                cancelButtonText: "NO",
            });
            if (isConfirm === true) {
                const isDeleteUser = await deleteContactUsSocial(
                    social?.contactUsSocialId,
                    controllerRef.current?.signal,
                );
                if (isDeleteUser) {
                    tableRef.current.onQueryChange();
                    setModalForm(false);
                }
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);
    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <div className="d-flex flex-column">
                    {thisMenuPermission?.create && (
                        <div className="align-self-end col-12 col-sm-3 col-md-2 col-lg-1 col-xl-1">
                            <Button onClick={handleShowModalForm} className="t-btn-primary w-100">
                                {" "}
                                <Add /> Add
                            </Button>
                        </div>
                    )}
                    <div className="t-table-custom">
                        <MaterialTable
                            tableRef={tableRef}
                            components={{ Container: Box }}
                            title={""}
                            data={fetchData}
                            columns={columnsTableSocial()}
                            options={tableOptions}
                            actions={[
                                {
                                    icon: "edit",
                                    iconProps: { style: { fontSize: 18 }, className: "action-edit" },
                                    tooltip: "Edit",
                                    onClick: (event, rowData) => {
                                        // Do save operation
                                        handleShowModalEditForm(rowData);
                                    },
                                    hidden: !thisMenuPermission?.edit,
                                },
                                {
                                    icon: "delete",
                                    iconProps: { style: { fontSize: 18 }, className: "action-delete" },
                                    tooltip: "Delete",
                                    onClick: (event, rowData) => handleDeleteSocial(rowData),
                                    hidden: !thisMenuPermission?.delete,
                                },
                            ]}
                        />
                    </div>
                </div>
            </Grid>
            {/* modal */}
            <Grid item xs={12}>
                <Modal show={modalForm} size="lg" centered={true} scrollable={true} onHide={HandleCloseModal}>
                    <Modal.Header>
                        {/* <h4 className="mb-0">Form</h4> */}
                        <Modal.Title>{isCreateMode ? "Create Social" : "Edit Social"}</Modal.Title>
                        <IconButton onClick={HandleCloseModal} size="small">
                            <Close />
                        </IconButton>
                    </Modal.Header>
                    <ModalBody>
                        <SocialForm
                            onSubmit={isCreateMode ? handleCreateSocial : handleUpdateSocial}
                            isCreateMode={isCreateMode}
                            contactUsSocialValues={contactUsSocialValues}
                            fileIcon={fileIcon}
                            setFileIcon={setFileIcon}
                        />
                    </ModalBody>
                </Modal>
            </Grid>
        </Grid>
    );
}
